module.exports = __webpack_public_path__ + "static/media/study220221.26bee852.png";